import { useStore, buildWhatsappLink } from "../lib/store";
import { Tag, ArrowRight } from "lucide-react";

export const Promotions = () => {
  const { promotions, business } = useStore();

  const askPromo = (p) => {
    const msg = `Hola AURA! Estoy interesada en la promoción: "${p.title}". ¿Me puedes dar más información?`;
    window.open(buildWhatsappLink(business.whatsappNumberOnly || business.whatsapp, msg), "_blank");
  };

  if (!promotions || promotions.length === 0) return null;

  return (
    <section id="promociones" className="section-padding bg-ink relative overflow-hidden" data-testid="promotions-section">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-[0.06]">
        <div className="absolute top-10 left-10 w-72 h-72 rounded-full border border-gold"></div>
        <div className="absolute top-32 left-32 w-72 h-72 rounded-full border border-gold"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full border border-gold"></div>
      </div>

      <div className="container-aura relative">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs tracking-luxe uppercase text-gold mb-4">Promociones</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-5">
            Ofertas <span className="italic text-gold">exclusivas</span>
          </h2>
          <div className="gold-divider mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-white/70 font-light">
            Aprovecha nuestras promociones y combos especiales diseñados para mimarte.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 md:gap-8">
          {promotions.map((p, i) => (
            <article
              key={p.id}
              data-testid={`promo-card-${p.id}`}
              className={`group relative rounded-3xl overflow-hidden bg-white/5 backdrop-blur-sm border border-white/10 hover:border-gold transition-all duration-500 ${i === 1 ? "lg:scale-105 lg:shadow-[0_30px_80px_-20px_rgba(212,175,55,0.3)]" : ""}`}
            >
              <div className="aspect-[5/4] overflow-hidden relative">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent"></div>
                <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gold text-white text-[10px] tracking-luxe uppercase font-medium">
                  <Tag size={12} />
                  {p.badge || "Oferta"}
                </div>
                <div className="absolute bottom-4 right-4 bg-white rounded-2xl px-4 py-2">
                  <div className="font-serif text-xl text-gold leading-none">{p.discount}</div>
                </div>
              </div>
              <div className="p-7">
                <h3 className="font-serif text-2xl text-white mb-2 leading-tight">{p.title}</h3>
                <p className="text-sm text-white/70 leading-relaxed font-light mb-6 min-h-[60px]">
                  {p.description}
                </p>
                <button
                  onClick={() => askPromo(p)}
                  data-testid={`promo-claim-${p.id}`}
                  className="inline-flex items-center gap-1.5 text-sm tracking-luxe uppercase text-gold hover:text-white transition-colors group/btn"
                >
                  Reclamar oferta
                  <ArrowRight size={14} className="transition-transform group-hover/btn:translate-x-1" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
